import { createAction } from '@reduxjs/toolkit';
import { LocalizedVacancyItemResponse } from './vacancies.types';

export const clearVacanciesItemsAction = createAction('vacancies/clear');
export const clearCandidateVacanciesAction = createAction('vacancies/clearCandidateVacancies');
export const updatesVacanciesOptionsAction = createAction<LocalizedVacancyItemResponse[]>(
  'vacancies/updatesVacanciesOptions',
);
export const clearVacanciesOptionsAction = createAction('vacancies/clearVacanciesOptions');
